import classNames from "classnames";
import isNumber from "lodash/isNumber";
import Form, { Field as BaseField } from "rc-field-form";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Card, CardHeader, Col, Row } from "reactstrap";
import Button from "../../../../components/Button";
import Field from "../../../../components/Field";
import NumberInput from "../../../../components/Inputs/NumberInput";
import Switch from "../../../../components/Inputs/Switch";
import { useConfigurationActions } from "../api/useConfiguration";
import { useConfigurationModule } from "../hooks/useConfigurationModule";

const options = [
    "expiration",
];

function Expiration() {
    const { t } = useTranslation();

    const types = [
        "shift",
        "edit-shift",
        "edit-timesheet",
        "absence",
        // "schedule",
        // "edit-schedule",
        // "submit-schedule",
        // "swap-shifts",
        // "offer-shifts",
        // "availability",
    ];

    return (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "1rem 4rem",
                gridAutoRows: "50px",
            }}
        >
            {types.map((type) => (
                <Field
                    key={type}
                    name={["expiration", type]}
                    className="mb-0 d-flex gap-4 align-items-center justify-content-between w-100"
                >
                    {({ value, onChange }) => {
                        return (
                            <>
                                <Switch
                                    checked={isNumber(value)}
                                    onChange={(e) => onChange(e.target.checked ? 0 : undefined)}
                                >
                                    {t(type)}
                                </Switch>

                                {isNumber(value) && (
                                    <span className="d-flex gap-2 align-items-center">
                                        <NumberInput
                                            className="w-auto"
                                            value={value}
                                            onChange={(e) => onChange(Number(e.target.value) || 0)}
                                        />
                                        <span>{t("days")}</span>
                                    </span>
                                )}
                            </>
                        );
                    }}
                </Field>
            ))}
        </div>
    );
}

function Requests() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [menu, setMenu] = useState(options[0]);

    let content;
    switch (menu) {
        case "expiration":
            content = <Expiration />;
            break;
    }

    const config = useConfigurationModule("requests");
    const { submit, submitting } = useConfigurationActions("requests");

    const onFinish = async (formValues) => {
        try {
            await submit({
                entity: "company",
                config: formValues,
            });
            toast.success(t("requests-configuration-saved"));
        } catch (err) {
            toast.error(t("could-not-save-requests-configuration"));
        }
    };

    useEffect(() => {
        form.setFieldsValue(config)
    }, [config]);

    return (
        <Card className="h-100">
            <Form form={form} onFinish={onFinish}>
                <CardHeader>
                    <Row>
                        <Col xs="6" className="pl-4 d-flex">
                            <h3 className="mb-0 mr-5">{t("requests")}</h3>
                        </Col>
                        <Col className="text-right" xs="6">
                            <Button
                                className="btn-dark px-3 btn-round btn-icon"
                                size="sm"
                                loading={submitting}
                                disabled={submitting}
                                type="submit"
                            >
                                {t("save")}
                            </Button>
                        </Col>
                    </Row>
                </CardHeader>

                <div className="px-4 py-3">
                    <div className="d-flex justify-content-start flex-wrap gap-2 pb-3">
                        {options.map((option) => <span
                            className={classNames(menu === option
                                ? "border border-primary text-white bg-primary font-weight-bold rounded px-3 py-2"
                                : "border border-primary text-primary font-weight-bold rounded px-3 py-2",
                                "cursor-pointer"
                            )}
                            onClick={() => setMenu(option)}
                        >
                            {t(option)}
                        </span>)}
                    </div>

                    <div className="pt-4">
                        {content}

                        <BaseField name="expiration" />
                    </div>
                </div>
            </Form>
        </Card>
    );
};

export default Requests;